import React from 'react';
import { MemoryGameProvider } from './MemoryGameContext';
import { useMemoryGame } from './MemoryGameContext';
import { GameBoard } from './GameBoard';
import { ResultScreen } from './ResultScreen';
import { MemoryHUD } from './MemoryHUD';

const MemoryGameContent: React.FC = () => {
  const { state } = useMemoryGame();

  return (
    <div className="min-h-screen bg-gray-50 py-2 sm:py-4">
      <div className="max-w-6xl mx-auto px-3 sm:px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left side - Game Board */}
          <div className="lg:col-span-2">
            <header className="text-center mb-4">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Memory Palace</h1>
              <p className="text-sm sm:text-base text-gray-600 mt-2 px-2">
                {state.phase === 'memorization' 
                  ? 'Memorize the positions of the objects!'
                  : state.phase === 'recall'
                  ? 'Now place the objects back in their original positions!'
                  : 'Great job! Check your results below.'}
              </p>
            </header>

            {state.phase === 'result' ? (
              <ResultScreen />
            ) : (
              <GameBoard />
            )}
          </div>

          {/* Right side - HUD */}
          {state.phase !== 'result' && (
            <div className="lg:col-span-1">
              <MemoryHUD />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const MemoryGame: React.FC = () => {
  return (
    <MemoryGameProvider>
      <MemoryGameContent />
    </MemoryGameProvider>
  );
};